import dolomiten from './images/dolomiten.svg'
import zett from './images/zett.svg'

export default {
  dolomiten,
  zett,
}
